import { AtomHttpApi } from "@effect-atom/atom";
import {
  FetchHttpClient,
  HttpApi,
  HttpApiEndpoint,
  HttpApiGroup,
} from "@effect/platform";
import { Schema } from "effect";
import {
  FiddleResponse,
  TransformRequest,
  TransformResponse,
  SaveFiddleRequest,
  SaveFiddleResponse,
  PdfRequest,
  PdfResponse,
  DefaultsResponse,
} from "@xsltransform/shared";

// Path parameters
const FiddleIdPath = Schema.Struct({
  id: Schema.String,
});

const FiddleRevisionPath = Schema.Struct({
  id: Schema.String,
  revision: Schema.NumberFromString,
});

// Define the API schema
class XsltApi extends HttpApi.make("xslt")
  .add(
    HttpApiGroup.make("fiddle")
      .add(
        HttpApiEndpoint.get("load", "/fiddle/:id")
          .setPath(FiddleIdPath)
          .addSuccess(FiddleResponse)
      )
      .add(
        HttpApiEndpoint.get("loadRevision", "/fiddle/:id/:revision")
          .setPath(FiddleRevisionPath)
          .addSuccess(FiddleResponse)
      )
      .add(
        HttpApiEndpoint.post("save", "/fiddle")
          .setPayload(SaveFiddleRequest)
          .addSuccess(SaveFiddleResponse)
      )
      .prefix("/api")
  )
  .add(
    HttpApiGroup.make("transform")
      .add(
        HttpApiEndpoint.post("run", "/transform")
          .setPayload(TransformRequest)
          .addSuccess(TransformResponse)
      )
      .prefix("/api")
  )
  .add(
    HttpApiGroup.make("pdf")
      .add(
        HttpApiEndpoint.post("generate", "/pdf")
          .setPayload(PdfRequest)
          .addSuccess(PdfResponse)
      )
      .prefix("/api")
  )
  .add(
    HttpApiGroup.make("defaults")
      .add(
        HttpApiEndpoint.get("load", "/defaults").addSuccess(DefaultsResponse)
      )
      .prefix("/api")
  ) {}

// Get base URL - empty for relative paths (dev proxy), or origin for production
const getBaseUrl = (): string => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "";
  }
  return window.location.origin;
};

// Create the client Tag
export class ApiClient extends AtomHttpApi.Tag<ApiClient>()("ApiClient", {
  api: XsltApi,
  httpClient: FetchHttpClient.layer,
  baseUrl: getBaseUrl(),
}) {}
